<template>
    <!-- Modal -->
      <b-modal 
        :id="modalId"
        hide-footer 
        centered
        no-close-on-backdrop
        body-class="col-12">
            <b-row class="mx-auto">
                <b-col
                    v-if="includeLoader && processing" 
                    cols="12" 
                    class="mx-auto">
                    <loader-version2 />
                </b-col>
                <b-col
                    v-else
                    cols="12" 
                    class="mx-auto d-flex flex-column align-items-center">
                    <slot name="body">
                    </slot>
                    <!-- botones -->
                    <div 
                        :class="includeButtonCancel ? 'd-flex col-12 col-sm-8 justify-content-between m-3' : 'm-3' ">
                        <button 
                            class="button-v2" 
                            :class="validModule('permisos-sindicales') ? 'primary-permisos-sindicales': 'primary'"
                            :disabled="disableAcceptedButton"
                            @click.prevent="$emit('click:accepted')">
                            <slot name="buttonText">
                            </slot>
                        </button>
                        <button
                            v-if="includeButtonCancel"
                            class="button-v2 outline-primary " 
                            @click.prevent="$bvModal.hide(modalId)">
                            <slot name="buttonCancel">
                              <strong>Cancelar</strong>
                            </slot>
                        </button>
                    </div>
                    <!-- end -->
                </b-col>
            </b-row>
      </b-modal>
    <!-- end -->
</template>

<script> 
export default {
    name: 'ModalConfirmation',
    props: {
        includeLoader: Boolean,
        processing: Boolean,
        modalId: String,
        includeButtonCancel: Boolean,
        disableAcceptedButton: Boolean
    }
}
</script>

<style lang="scss">
    .primary-permisos-sindicales {
        background-color: #0E333A;
    }
</style>